// extracted by mini-css-extract-plugin
export var disabled = "_13-a";
export var hierarchyLinkGray = "_13-4";
export var hierarchyLinkUnderline = "_13-3";
export var hierarchyPrimary = "_13-0";
export var hierarchySecondary = "_13-1";
export var hierarchyTertiary = "_13-2";
export var pressed = "_13-6";
export var themeAction = "_13-5";
export var themeDestructive = "_13-8";
export var themeNormal = "_13-7";
export var themeSuccess = "_13-9";